import { render, staticRenderFns } from "./ModalAddSportDataMatch.vue?vue&type=template&id=1e39f2dc&"
import script from "./ModalAddSportDataMatch.vue?vue&type=script&lang=js&"
export * from "./ModalAddSportDataMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports